module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/mobile-easy-invoicing@2x-ba46fb94373a46907942c9186a4bed47.png";